import styled from "styled-components";
import { colors } from "../../colors";

export const LavaFloorPageContainer = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  justify-content: space-between;
  padding: 16px 0 32px;
  box-sizing: border-box;
  p {
    margin: 5px;
  }
`;

export const HeaderTitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

export const ContainerTitle = styled.p`
  font-size: 24px;
  color: white;
`;

export const GameInfoTitle = styled.p`
  font-size: 20px;
  color: ${colors.textBlue};
`;

export const ScoreChips = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 700;
  img {
    width: 34px;
    object-fit: contain;
  }
`;

export const FloorStatusLine = styled.p<{ $online: boolean }>`
  font-size: 13px;
  color: ${(props) => (props.$online ? "#7CCB9B" : "#FF7B7B")};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const MiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 10px;
  flex: 1;
  justify-content: center;
`;

export const LevelSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 22px;
`;

export const LevelArrow = styled.button`
  background: transparent;
  border: 2px solid white;
  color: white;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  font-size: 22px;
  cursor: pointer;
`;

export const LevelName = styled.p`
  min-width: 160px;
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  color: ${colors.textBlue};
`;

export const TeamsRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  width: 100%;
`;

export const TeamCard = styled.div<{ $selected: boolean; $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  min-width: 150px;
  min-height: 120px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 12px;
  background-color: ${(props) =>
    props.$selected ? "rgba(255, 255, 255, 0.2)" : "transparent"};
  border: ${(props) =>
    props.$selected ? `2px solid ${colors.textBlue}` : "2px solid transparent"};
  opacity: ${(props) => (props.$disabled ? 0.4 : 1)};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
  cursor: pointer;
  p {
    font-size: 18px;
  }
  img {
    width: 64px;
    object-fit: contain;
  }
  span {
    font-weight: 700;
    font-size: 20px;
    color: ${colors.textBlue};
  }
`;

export const BigTime = styled.p`
  font-size: 64px;
  font-weight: 700;
  color: white;
  margin: 0;
`;

export const SubInfo = styled.p`
  font-size: 18px;
  color: #aab6cc;
  text-align: center;
`;

export const Message = styled.p`
  font-size: 16px;
  color: ${colors.primaryOrange};
  text-align: center;
  min-height: 20px;
  width: 80%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  transform: skew(-0.03turn, 0deg);
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 305px;
  height: 68px;
  background-color: ${colors.primaryOrange};
  color: white;
  border: none;
  font-size: 24px;
  cursor: pointer;
  &:disabled {
    opacity: 0.4;
  }
  p {
    transform: skew(0.03turn, 0deg);
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 305px;
  height: 52px;
  background-color: transparent;
  color: white;
  border: 2px solid white;
  font-size: 18px;
  cursor: pointer;
  p {
    transform: skew(0.03turn, 0deg);
  }
`;

export const SettingsToggle = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  padding: 8px 12px;
  color: white;
  border-radius: 50%;
  border: 1px solid white;
  cursor: pointer;
  font-size: 18px;
`;

export const SettingsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  width: 90%;
  max-width: 360px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 12px;
  padding: 12px;
  input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid white;
    background: transparent;
    color: white;
    font-size: 16px;
  }
  small {
    color: #aab6cc;
    text-align: center;
  }
`;
